export function BrightEdgeContainer() {
  return <div className="be-ix-link-block" />;
}
